import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFeestdag = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F8BADD"
      fillRule="evenodd"
      d="M13 16a5 5 0 0 1 1.582 9.745L15 27h-4l.418-1.255A5.002 5.002 0 0 1 13 16"
      clipRule="evenodd"
    />
    <path
      fill="#F170B8"
      fillRule="evenodd"
      d="M23 7a9 9 0 0 1 2.24 17.719L26 27h-6l.759-2.281A9 9 0 0 1 23 7"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M23 25h-1v4a3.5 3.5 0 0 0 3.5 3.5v-1A2.5 2.5 0 0 1 23 29zM12.5 27h1v2a1.5 1.5 0 0 0 1.5 1.5v1a2.5 2.5 0 0 1-2.5-2.5zM22.5 8.5v1A6.5 6.5 0 0 1 29 16h1a7.5 7.5 0 0 0-7.5-7.5"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFeestdag);

export default ForwardRef;
